/* tslint:disable */
/* eslint-disable */
/**
 * Risk Management System API
 * Risk Management System API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ApiClientDetails } from './ApiClientDetails';
import {
    ApiClientDetailsFromJSON,
    ApiClientDetailsFromJSONTyped,
    ApiClientDetailsToJSON,
    ApiClientDetailsToJSONTyped,
} from './ApiClientDetails';

/**
 * 
 * @export
 * @interface ApiClientDetailsPage
 */
export interface ApiClientDetailsPage {
    /**
     * 
     * @type {Array<ApiClientDetails>}
     * @memberof ApiClientDetailsPage
     */
    clients: Array<ApiClientDetails>;
}

/**
 * Check if a given object implements the ApiClientDetailsPage interface.
 */
export function instanceOfApiClientDetailsPage(value: object): value is ApiClientDetailsPage {
    if (!('clients' in value) || value['clients'] === undefined) return false;
    return true;
}

export function ApiClientDetailsPageFromJSON(json: any): ApiClientDetailsPage {
    return ApiClientDetailsPageFromJSONTyped(json, false);
}

export function ApiClientDetailsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiClientDetailsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'clients': ((json['clients'] as Array<any>).map(ApiClientDetailsFromJSON)),
    };
}

export function ApiClientDetailsPageToJSON(json: any): ApiClientDetailsPage {
    return ApiClientDetailsPageToJSONTyped(json, false);
}

export function ApiClientDetailsPageToJSONTyped(value?: ApiClientDetailsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clients': ((value['clients'] as Array<any>).map(ApiClientDetailsToJSON)),
    };
}

